import { Component, ChangeDetectorRef, OnInit, OnDestroy, Input } from '@angular/core';

import { Subject, filter, takeUntil } from 'rxjs';

import { TwcSliderValue } from '@topcon/twc-angular';

import { WidgetType } from '@mirage-projects/cw-commons';

import { SideSliderService } from './side-slider.service';

/**
 * It shows a slider bar with a vertical guideline. It is used by Side by Side tool.
 */
@Component({
    selector: 'cw-side-slider',
    templateUrl: './side-slider.component.html',
    styleUrls: ['./side-slider.component.scss'],
    standalone: false,
})
export class SideSliderComponent implements OnInit, OnDestroy {
    @Input() viewId: WidgetType | undefined;

    isEnabled = false;
    valueSlider = 50;
    areColorsInverted = false;

    onDestroy$: Subject<void> = new Subject();

    constructor(
        private cdr: ChangeDetectorRef,
        private sideSliderService: SideSliderService
    ) {}

    ngOnInit(): void {
        this.sideSliderService.visibilityChange$
            .pipe(
                takeUntil(this.onDestroy$),
                filter((sliderVisibility) => sliderVisibility.id === this.viewId)
            )
            .subscribe((sliderVisibility) => {
                this.isEnabled = sliderVisibility.visible;
                this.cdr.detectChanges();
            });

        this.sideSliderService.invertColors$.pipe(takeUntil(this.onDestroy$)).subscribe((areColorsInverted) => {
            this.areColorsInverted = areColorsInverted;
        });
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    /** Propagates slider values to SideSliderService and enable the vertical guideline to be updated
     * @param value change value by user interaction
     */
    changeValueSlider(value: TwcSliderValue): void {
        this.cdr.detectChanges();
        const idWidget = this.viewId || '3D';
        this.sideSliderService.emitSideSliderValue(idWidget, value as number);
    }
}
